import * as errors from '@attain-apps/errors'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * When a render request is made, plugin attempts to execute the API request,
 * and send out the appropriate success or error action afterwards
 */
export const getRenderOnRequest = store.effects.create((feature: Feature) =>
  feature.actions.render.request.observe().pipe(
    rxjs.mergeMap(action => {
      // We get the rendering using the API
      const render$ = feature.api.render(action.data)
      // NOTE: Mosaic developers are allowed to return `undefined` when they
      // want to have an empty rendering
      return render$.pipe(
        // Handles success
        rxjs.map((rendering = {}) =>
          feature.actions.render.success.from(action).create({
            request: action.data,
            response: { rendering },
          }),
        ),
        // Handles error
        rxjs.catchError(error =>
          rxjs.of(
            feature.actions.render.error.from(action).create({
              error,
              request: action.data,
            }),
          ),
        ),
      )
    }),
  ),
)
